/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FirstPayerRowFromJSON, FirstPayerRowToJSON } from './FirstPayerRow';
import { FirstPaymentCohortRowFromJSON, FirstPaymentCohortRowToJSON } from './FirstPaymentCohortRow';
/**
 * Check if a given object implements the FirstPaymentCohortsResponse interface.
 */
export function instanceOfFirstPaymentCohortsResponse(value) {
    if (!('cohorts' in value) || value['cohorts'] === undefined)
        return false;
    if (!('recentFirstPayments' in value) || value['recentFirstPayments'] === undefined)
        return false;
    if (!('totalPaidUsers' in value) || value['totalPaidUsers'] === undefined)
        return false;
    if (!('writeFailuresTotal' in value) || value['writeFailuresTotal'] === undefined)
        return false;
    return true;
}
export function FirstPaymentCohortsResponseFromJSON(json) {
    return FirstPaymentCohortsResponseFromJSONTyped(json, false);
}
export function FirstPaymentCohortsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cohorts': (json['cohorts'].map(FirstPaymentCohortRowFromJSON)),
        'recentFirstPayments': (json['recentFirstPayments'].map(FirstPayerRowFromJSON)),
        'totalPaidUsers': json['totalPaidUsers'],
        'writeFailuresTotal': json['writeFailuresTotal'],
    };
}
export function FirstPaymentCohortsResponseToJSON(json) {
    return FirstPaymentCohortsResponseToJSONTyped(json, false);
}
export function FirstPaymentCohortsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cohorts': (value['cohorts'].map(FirstPaymentCohortRowToJSON)),
        'recentFirstPayments': (value['recentFirstPayments'].map(FirstPayerRowToJSON)),
        'totalPaidUsers': value['totalPaidUsers'],
        'writeFailuresTotal': value['writeFailuresTotal'],
    };
}
